import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const navLinks = [
    { name: '首页', path: '/' },
    { name: '电影', path: '/category/movie' },
    { name: '电视剧', path: '/category/tv' },
    { name: '动漫', path: '/category/anime' },
    { name: '综艺', path: '/category/variety' },
    { name: '纪录片', path: '/category/documentary' },
    { name: '资讯', path: '/article/article-1' },
    { name: '关于我们', path: '/about' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="font-heading text-2xl font-bold text-primary-600">
              成全影视
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-primary-600 bg-primary-100/70'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors cursor-pointer" aria-label="搜索">
              <i className="ri-search-line text-foreground-600 text-lg"></i>
            </button>
            <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors cursor-pointer" aria-label="历史记录">
              <i className="ri-history-line text-foreground-600 text-lg"></i>
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-md bg-background-100 cursor-pointer"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-foreground-700 text-lg ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2.5 text-sm rounded-md transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-primary-600 bg-primary-100/70 font-medium'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}